import { useEffect, useMemo, useState } from "react";
import Button from "../design/Button";
import GModal from "../design/components/GModal";
import musicFileIcon from "../../assets/music file icon.svg";
import { formatFileSize } from "../../utility-functions";
import CloseIcon from "@mui/icons-material/Close";
import listenIcon from "../../assets/listen-icon-green.svg";
import { MenuItem } from "@mui/material";
import { JService } from "../api-service/ApiService";
import EditOrderModal from "./EditOrderModal";
import { topNavAccountSelectedAccountTickIcon } from "../../utility-functions/assetLoader";
import commonStyles from "../design/commonStyles";
import { enqueueSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CustomSearchableDropdown, CustomSelect } from "../design/components/customComponents";
import AnimationPage from "../shared/animation-page/AnimationPage";

const connectToOptions = [
  {value: "user", displayValue: "User"},
  {value: "team", displayValue: "Team"},
  {value: "ivr", displayValue: "IVR flow"},
  {value: "none", displayValue: "No one"},
]

const callDistributionOptionsContent = [
  {id: 5, title: "Simultaneous ringing", helpText: "Calls ring on all available users' at once, first to respond takes the call."},
  {id: 1, title: "Round Robin", helpText: "Calls are distributed to users in rotational order, following a cyclical pattern through team members."},
  {id: 2, title: "Fixed Order", helpText: "Calls are distributed to users in predetermined order, following a set sequence that remains constant."},
  {id: 3, title: "Longest Idle", helpText: "Calls are distributed to the user who has been idle for the longest period of time."},
  {id: 4, title: "Sticky Agent", helpText: "Connects caller to the same agent with whom they had conversation in previous call."}
]

function IncomingTab({ originalSettings, setOriginalSettings, showLoader }) {
  const navigate = useNavigate();
  const virtualNumberId = originalSettings?.id;
  const [workingHoursMsgType, setWorkingHoursMsgType] = useState("none");
  const [workingHoursMsgFile, setworkingHoursMsgFile] = useState([]);
  const [workingHoursMsgURL, setWorkingHoursMsgURL] = useState("");
  const [workingHoursFileChanged, setWorkingHoursFileChanged] = useState(false);

  const [connectToType, setConnectToType] = useState("user");
  const [connectToUser, setConnectToUser] = useState("");
  const [connectToTeam, setConnectToTeam] = useState("");
  const [callDistribution, setCallDistribution] = useState(1);
  const [showEditOrderModal, setShowEditOrderModal] = useState(false);

  const [afterHoursMsgType, setAfterHoursMsgType] = useState("none");
  const [afterHoursMsgFile, setAfterHoursMsgFile] = useState([]);
  const [afterHoursMsgURL, setAfterHoursMsgURL] = useState("");
  const [afterHoursFileChanged, setAfterHoursFileChanged] = useState(false);

  const [showAudioModal, setShowAudioModal] = useState(false);
  const [audioModalURL, setaudioModalURL] = useState("");
  
const [selectedIVRFlow, setSelectedIVRFlow] = useState("");
const [ivrFlows, setIvrFlows] = useState([]);



const ivrOptions = [
  { id: "new", name: "New Flow", style: { color: "#219848" } },
  ...ivrFlows.map((flow) => ({
    ...flow,
    name: flow.title,
  })),
];



  const reduxSubscription = useSelector(state=>state?.account?.value?.subscription);
  const { canManageIvrFlow } = useSelector((state) => state?.auth?.permissions);
  useEffect(() => {
    if (originalSettings.working_hours_message) {
      setWorkingHoursMsgURL(originalSettings.working_hours_message.url);
      setWorkingHoursMsgType("audio");
      setworkingHoursMsgFile(
        [].concat([{ name: originalSettings.working_hours_message.name }]),
      );
    } else {
      setWorkingHoursMsgURL("");
      setWorkingHoursMsgType("none");
      setworkingHoursMsgFile([]);
    }

    if (originalSettings.after_hours_message) {
      setAfterHoursMsgURL(originalSettings.after_hours_message.url);
      setAfterHoursMsgType("audio");
      setAfterHoursMsgFile(
        [].concat([{ name: originalSettings.after_hours_message.name }]),
      );
    } else {
      setAfterHoursMsgURL("");
      setAfterHoursMsgType("none");
      setAfterHoursMsgFile([]);
    }

    if(originalSettings.ivr_flow) {
      setConnectToType("ivr");
      setSelectedIVRFlow(originalSettings.ivr_flow);
    }
    else if (originalSettings.inbound_user) {
      setConnectToType("user");
      setConnectToUser(originalSettings.inbound_user.id);
    } else if (originalSettings.inbound_team) {
      setConnectToType("team");
      setConnectToTeam(originalSettings.inbound_team);
      setCallDistribution(originalSettings.call_distribution);
    } else {
      setConnectToType("none");
      setConnectToUser(null);
      setConnectToTeam(null);
    }
  }, [originalSettings]);

  const isSaveDisabledWorkingHours = () => {
    const originalAudioType =
      originalSettings?.working_hours_message === null ? "none" : "audio";
    const originalConnectType =
      originalSettings?.inbound_team === null ? originalSettings?.inbound_user === null ? originalSettings.ivr_flow === null? "none" : "ivr" : "user" : "team";

    // 1] Check if there are incomplete fileds
    if (
      (connectToType === "user" && connectToUser === "") ||
      (connectToType === "team" && connectToTeam === "") ||
      (connectToType === "ivr" && !selectedIVRFlow) ||
      (workingHoursMsgType !== originalAudioType &&
        workingHoursMsgType === "audio" &&
        workingHoursMsgFile?.length === 0)
    )
      return true;

    // 2] Check if a field has changed and can be updated

    // 2a] Check if audio field changed
    // If type changed
    if (workingHoursMsgType !== originalAudioType) {
      if (workingHoursMsgType === "none") return false;
      else if (workingHoursMsgType === "audio") {
        if (workingHoursMsgFile?.length !== 0) return false;
      }
    }
    // if type not changed and type is audio
    else {
      if (workingHoursMsgType === "audio") {
        if (workingHoursMsgFile?.length === 0) return false;
        else if (workingHoursFileChanged) return false;
      }
    }

    // 2b] Check if connect to field changed
    // if type changed -> enable save
    if (originalConnectType !== connectToType) return false;
    // else if type is unchanged
    else {
      if (
        connectToType === "user" &&
        connectToUser != originalSettings?.inbound_user?.id
      )
        return false;
      else if (connectToType === "team") {
        if (connectToTeam != originalSettings?.inbound_team) return false;
        else if (callDistribution != originalSettings?.call_distribution)
          return false;
      }
      else if(connectToType === "ivr") {
        return originalSettings.ivr_flow === selectedIVRFlow;
      }
    }
    // if type is user(unchanged) but selected user is changed => enable save

    return true;
  };

  const isSaveDisabledAfterHours = () => {
    const originalType =
      originalSettings.after_hours_message === null ? "none" : "audio";

    // If type changed
    if (afterHoursMsgType !== originalType) {
      if (afterHoursMsgType === "none") return false;
      else if (afterHoursMsgType === "audio") {
        if (afterHoursMsgFile?.length !== 0) return false;
        else return true;
      }
    }
    // if type not changed and type is audio
    else {
      if (afterHoursMsgType === "audio") {
        if (afterHoursMsgFile?.length === 0) return false;
        else if (afterHoursFileChanged) return false;
        else return true;
      } else return true;
    }
  };

  const createRecording = async (audioFile) => {
    /*
      audioFile = file to be uploaded to cloud
    */
    const audioFormData = new FormData();
    audioFormData.append("audio_file", audioFile);

    try {
      const response = await JService.post(
        "/api/v1/core/create-recording/",
        audioFormData,
      );
      console.log(response);
      if (!response?.success)
        throw new Error(response?.message || "Could not upload the file");
      return response.data.id;
    } catch (err) {
      enqueueSnackbar(err?.message, { variant: "error" });
    }
  };

  function updateVirtualNumberAPICall(payload) {
    JService.patch(
      `/api/v1/auth/virtual-numbers/calling/${originalSettings.id}/`,
      payload,
    )
      .then((res) => {
        if (!res?.success)
          throw new Error(
            res?.message || "Error while updating virtual number",
          );
        enqueueSnackbar(res?.message, { variant: "success" });
        setOriginalSettings(res.data);
        setAfterHoursFileChanged(false);
        setWorkingHoursFileChanged(false);
      })
      .catch((err) => enqueueSnackbar(err?.message, { variant: "error" }));
  }

  function handleSave(type) {
    let payload = {};
  
    if (type === "working-hrs") {
      if (connectToType === "user") {
        payload = {
          inbound_user_id: connectToUser,
          inbound_team_id: null,
          ivr_flow: null
        };
      } else if (connectToType === "team") {
        if (connectToTeam !== originalSettings.inbound_team) {
          const _temp = originalSettings.all_teams
            .filter((team) => team.id === connectToTeam)[0]
            .users.map((user) => user.id);
          payload = {
            inbound_user_id: null,
            inbound_team_id: connectToTeam,
            call_distribution: callDistribution,
            routing_order: _temp,
            ivr_flow: null
          };
        } else {
          payload = { inbound_user_id: null, call_distribution: callDistribution };
        }
      } else if (connectToType === "ivr") {
        // payload = { inbound_ivr_flow_id: selectedIVRFlow };
        payload = {
          inbound_user_id: null,
          inbound_team_id: null,
          ivr_flow: selectedIVRFlow
        };
      } else if (connectToType === "none") {
        payload = {
          inbound_user_id: null,
          inbound_team_id: null,
          inbound_ivr_flow_id: null,
          ivr_flow: null
        };
      }
  
      if (workingHoursMsgType === "none" || workingHoursMsgFile.length === 0) {
        updateVirtualNumberAPICall({
          ...payload,
          working_hours_message_id: null,
        });
      } else if (workingHoursMsgType === "audio") {
        if (workingHoursFileChanged)
          createRecording(workingHoursMsgFile[0]).then((recordingId) =>
            updateVirtualNumberAPICall({
              ...payload,
              working_hours_message_id: recordingId,
            }),
          );
        else {
          updateVirtualNumberAPICall(payload);
        }
      }
    } else if (type === "after-hrs") {
      if (afterHoursMsgType === "none" || afterHoursMsgFile.length === 0) {
        updateVirtualNumberAPICall({ after_hours_message_id: null });
      } else if (afterHoursMsgType === "audio") {
        if (afterHoursFileChanged)
          createRecording(afterHoursMsgFile[0]).then((recordingId) => {
            updateVirtualNumberAPICall({ after_hours_message_id: recordingId });
          });
        else {
          updateVirtualNumberAPICall(payload);
        }
      }
    }
  }
  

  const handleAudioFileUpload = async (event, setFile, setAudioURL) => {
    const audioFile = event.target.files[0];

    const loadAudioMetaData = (file) =>
      new Promise((res, rej) => {
        const audio = document.createElement("audio");
        audio.preload = "metadata";
        audio.onloadedmetadata = () => res(audio);
        audio.onerror = () => {
          enqueueSnackbar("Please upload an audio file of the right format", {
            variant: "error",
          });
          event.target.files[0] = "";
        };
        audio.src = URL.createObjectURL(file);
      });

    const _audio = await loadAudioMetaData(audioFile);
    if (_audio.duration > 45 || _audio.duration == 0) {
      enqueueSnackbar(
        "Please upload a valid audio file of duration 1 - 45 seconds",
        { variant: "error" },
      );
      event.target.value = "";
    } else {
      setFile([audioFile]);
      setAudioURL(URL.createObjectURL(audioFile));
    }
  };
  useEffect(() => {
    if(!canManageIvrFlow) return;
    JService.get("/api/v1/core/retrieve-ivr-flows/")
      .then((res) => {
        if (res.success) {
          setIvrFlows(res.data);
        } else {
          enqueueSnackbar(res.message || "Error fetching IVR flows", { variant: "error" });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message || "Error fetching IVR flows", { variant: "error" });
      });
  }, []);
  const UploadAudio = ({ file, setFile, setAudioURL, category }) => {
    return (
      <label htmlFor="upload-list-file" className="upload-file-label">
        {file.length === 0 && (
          <>
            <div className="no-file">
              <div>
                <a className="t6 ic-green-500">Click to upload</a>
                <span className="t6 medium-font">&nbsp;or drag and drop</span>
                <p className="t8 regular-font nc-gray-600">
                  File format: mp3 (max size: 10MB)
                </p>
              </div>
            </div>
            <input
              id="upload-list-file"
              placeholder="or drag and drop files here"
              className="t6 regular-font"
              name="file"
              type="file"
              // disabled={newListFile[0]?.name}
              accept={".mp3"}
              onChange={(e) => {
                handleAudioFileUpload(e, setFile, setAudioURL);
                if (category === "during") setWorkingHoursFileChanged(true);
                else if (category === "after") setAfterHoursFileChanged(true);
              }}
            />
          </>
        )}
        {file[0]?.name && (
          <>
            <div className="has-file">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img src={musicFileIcon} />
                <div
                  className="t6 regular-font"
                  style={{
                    marginLeft: "20px",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <p className="nc-gray-900 t6 regular-font">
                    {file[0].name.substring(0, 27)}
                    {file[0].name.length > 27 ? "…" : ""}
                  </p>

                  {!!file[0]?.size && (
                    <p className="nc-gray-600 t6 regular-font">
                      {formatFileSize(file[0]?.size)} z
                    </p>
                  )}
                </div>
              </div>
              <CloseIcon
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setFile([]);
                  setAudioURL("");
                }}
              />
            </div>
          </>
        )}
      </label>
    );
  };

  const WelcomeMessage = ({ category }) => {
    return (
      <>
        <CustomSelect
          label={category === "during" ? "Welcome message" : "After hours message"}
          value={category === "during"
              ? workingHoursMsgType
              : category === "after"
              ? afterHoursMsgType
              : "none"}
          handleChange={(e) => {
            if (category === "during") setWorkingHoursMsgType(e.target.value);
            else if (category === "after") setAfterHoursMsgType(e.target.value);
          }}
          renderVal={(selected) => {
            if (selected === "audio") return <p className="t7 regular-font">Audio file</p>;
            else
              return <p className="t7 regular-font">No message ({
                category === "during"
                  ? "Connect directly"
                  : "Disconnect automatically"
              })</p>;
          }}
          options ={[
            {
              value: "none", 
              displayValue: `No message (${
              category === "during"
                ? "Connect directly"
                : "Disconnect automatically"
            })`},
            {
              value: "audio",
              displayValue: "Audio file"
            }
          ]}
        />
        {category === "during" && workingHoursMsgType === "audio" && (
          <>
            <UploadAudio
              file={workingHoursMsgFile}
              setFile={setworkingHoursMsgFile}
              setAudioURL={setWorkingHoursMsgURL}
              category="during"
            />
            {!!workingHoursMsgURL && (
              <div
                className="listen-btn"
                onClick={() => {
                  setaudioModalURL(workingHoursMsgURL);
                  setShowAudioModal(true);
                }}
              >
                <img
                  style={{ width: "18px" }}
                  src={listenIcon}
                  alt="listen icon"
                />
                <p>Listen</p>
              </div>
            )}
          </>
        )}

        {category === "after" && afterHoursMsgType === "audio" && (
          <>
            <UploadAudio
              file={afterHoursMsgFile}
              setFile={setAfterHoursMsgFile}
              setAudioURL={setAfterHoursMsgURL}
              category="after"
            />
            {!!afterHoursMsgURL && (
              <div
                className="listen-btn"
                onClick={() => {
                  setaudioModalURL(afterHoursMsgURL);
                  setShowAudioModal(true);
                }}
              >
                <img
                  style={{ width: "18px" }}
                  src={listenIcon}
                  alt="listen icon"
                />
                <p>Listen</p>
              </div>
            )}
          </>
        )}
      </>
    );
  };

  const handleSelectIvrFlow = (id) => {
    if(canManageIvrFlow) {
      setSelectedIVRFlow(id);
      if (id === "new") {
        JService.post("/api/v1/core/create-ivr-flow/")
          .then(async (res) => {
            if (!res?.success || !(res?.data??{}).id) throw new Error(res?.message || "Error creating IVR flow");
            const newFlowId = res.data.id;
            // update settings: title and 'hang up immediately'
            try {
              const count = ivrFlows.map(flow => flow.title.toLowerCase().includes("ivr flow")).length;
              const newName = `IVR Flow - ${count+1}`;
              const payload = {
                title: newName,
                end_action: 2,
              }
              const response = await JService.patch(`/api/v1/core/ivr-flow/${newFlowId}/`, payload);
              if(!response?.success) throw new Error(response?.message);

            }
            catch(error) {
              console.error("error");
            }
            setSelectedIVRFlow(newFlowId);
            const url = `/virtual-numbers/ivr/edit?ivr-flow-id=${newFlowId}`;
            navigate(url, {state: {ivrId: newFlowId, virtualNumberId, virtualNumberCountryCode: originalSettings?.country_code, virtualNumber: originalSettings?.number, isNew: true, flowNamesInUse: ivrFlows.filter(flow => flow.id !== selectedIVRFlow).map(flow => (flow.title??"").toLowerCase())}});
          })
          .catch((err) => {
            enqueueSnackbar(
              err.message || "Error creating IVR flow",
              { variant: "error" }
            );
          });
      }
    }
  }

  const callDistributionOptions = useMemo(() => {
    return callDistributionOptionsContent.map((elem => {
      return (
        <MenuItem sx={{...commonStyles.menu_item, whiteSpace: 'normal'}} value={elem.id}>
          <div className="call-dist-options t7 regular-font">
            <p className="nc-gray-900">{elem.title}</p>
            <p className="nc-gray-600">{elem.helpText}</p>
          </div>
          {callDistribution === elem.id && topNavAccountSelectedAccountTickIcon()}
        </MenuItem>
      )
    }))
  }, [callDistribution]);

  return (
    <>
      {showLoader && <AnimationPage/>}
      {!showLoader && (
      <div>
        <p
          className="t5 medium-font"
          style={{ marginTop: "40px", marginBottom: "40px" }}
        >
          During business hours
        </p>

        <form
          className="new-contact-list-form add-contact-form virtual-numbers-form"
          style={{ maxWidth: "400px" }}
        >
        { reduxSubscription?.plan?.name?.includes("Professional") && <WelcomeMessage category="during" /> }
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px', marginTop: '20px'}}>
          <div className="select-container">
            <CustomSelect
              label="Connect to"
              value={connectToType}
              handleChange={(e) => {
                setConnectToType(e.target.value);
              }}
              options={connectToOptions}
              selectStyles={{width: '120px'}}
            />
          </div>
          
                {connectToType === "ivr" ? (
                 <div
                 style={{
                   display: "flex",
                   alignItems: "center",
                   gap: "8px",
                 }}
               >
                 <CustomSearchableDropdown
                   label="Select IVR flow"
                   placeholder="Search"
                   options={ivrOptions}
                   selectedId={selectedIVRFlow}
                   onSelect={handleSelectIvrFlow}
                   searchable={true}
                   width="272px"
                   align="start"
                   renderContainerStyleOverride={{
                    padding: "12px",
                    maxHeight: "39px"
                   }}
                 />
                 {selectedIVRFlow && selectedIVRFlow !== "new" && (
                   <div
                     onClick={() => navigate(`/virtual-numbers/ivr/edit?ivr-flow-id=${selectedIVRFlow}`, {state: {ivrId: selectedIVRFlow, virtualNumberId, virtualNumberCountryCode: originalSettings?.country_code, virtualNumber: originalSettings?.number, isNew: false, flowNamesInUse: ivrFlows.filter(flow => flow.id !== selectedIVRFlow).map(flow => (flow.title??"").toLowerCase())}})}
                     className="listen-btn"
                     style={{
                       cursor: "pointer",
                       minWidth: "75px",
                       marginLeft: "4px",
                       marginTop: "0px",
                     }}
                   >
                    <p>
                     Edit flow
                    </p>
                   </div>
                 )}
               </div>
                ) : (
                  (connectToType === "user" || connectToType === "team") && (
                    <div className="select-container">
                      <CustomSelect
                        label=""
                        value={connectToType === "user" ? connectToUser : connectToTeam}
                        handleChange={(e) => {
                          if (connectToType === "user") setConnectToUser(e.target.value);
                          else if (connectToType === "team") setConnectToTeam(e.target.value);
                        }}
                        renderVal={(selected) => {
                          if (
                            (connectToType === "user" && connectToUser === "") ||
                            (connectToType === "team" && connectToTeam === "")
                          )
                            return <p className="t7 regular-font">Select {connectToType}</p>
                          if (connectToType === "user") {
                            const selectedUserData = originalSettings?.all_users.find(
                              (user) => user.id === connectToUser
                            );
                            return <p className="t7 regular-font">{selectedUserData
                              ? (selectedUserData.first_name +
                                  " " +
                                  selectedUserData.last_name).trim()
                                ? selectedUserData.first_name +
                                  " " +
                                  selectedUserData.last_name
                                : selectedUserData.email
                              : null}</p>
                          } else if (connectToType === "team") {
                            const selectedTeamData = originalSettings?.all_teams.find(
                              (team) => team.id === connectToTeam
                            );
                            return <p className="t7 regular-font">{selectedTeamData?.name}</p>;
                          }
                        }}
                        options={connectToType === "user" ? 
                          originalSettings.all_users?.map(user => (
                            {
                              value: user.id,
                              displayValue: ((user.first_name || "") + " " + (user.last_name || "")).trim() || user.email 
                            }
                          )) : originalSettings.all_teams?.map((team) => ({value: team.id, displayValue: team.name}))
                        }
                        selectStyles={{width: '272px', marginTop: '20px'}}
                      />
                    </div>
                  )
                )}
            </div>
          {connectToType === "team" && (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginRight: "-150px",
                }}
              >
              <div className="select-container">
                <CustomSelect
                  label="Call Distribution"
                  value={callDistribution}
                  handleChange={(e) => setCallDistribution(e.target.value)}
                  renderVal={(selected) => (
                    <p className="t7 regular-font pNoOverflow">
                      {callDistributionOptionsContent.find(cd => cd.id === selected)?.title}
                    </p>
                  )}
                  extraOptions={callDistributionOptions}
                  selectStyles={{width: '400px'}}
                />
              </div>
                {callDistribution === 2 && !!connectToTeam && (
                  <div
                    className="listen-btn"
                    onClick={() => setShowEditOrderModal(true)}
                    style={{
                      marginBottom: "10px",
                      marginLeft: "14px",
                    }}
                  >
                    <p>Edit order</p>
                  </div>
                )}
              </div>
            </>
          )}

          <div style={{ marginTop: "20px", marginBottom: "36px" }}>
            <Button
              variant="filled"
              buttonText="Save"
              icon={{}}
              disabled={isSaveDisabledWorkingHours()}
              isLoading={false}
              hierarchy="green"
              onClick={() => handleSave("working-hrs")}
            />
          </div>
        </form>

        {reduxSubscription?.plan?.name?.includes("Professional") && (
          <div>
            <div
              style={{
                borderBottomWidth: "1px",
                borderBottomColor: "#E1E6E2",
                borderBottomStyle: "solid",
              }}
            ></div>

          <p className="t5 medium-font" style={{ marginTop: "36px", marginBottom: "40px" }}>
            After business hours
          </p>
          <form
            className="new-contact-list-form add-contact-form virtual-numbers-form"
            style={{ maxWidth: "400px" }}
          >
            <WelcomeMessage category="after" />
            <div style={{ marginTop: "20px", marginBottom: "36px" }}>
              <Button
                variant="filled"
                buttonText="Save"
                icon={{}}
                disabled={isSaveDisabledAfterHours()}
                isLoading={false}
                hierarchy="green"
                onClick={() => handleSave("after-hrs")}
              />
            </div>
          </form>
          </div>)}
      </div>
      )}

      <GModal
        visible={showAudioModal}
        closeModal={() => {
          setShowAudioModal(false);
        }}
        heading={"Message audio"}
        body={
          <>
            <audio
              controls
              style={{
                width: "100%",
                margin: 0,
                padding: 0,
                display: "block",
              }}
            >
              EditOrderModal
              <source src={audioModalURL} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          </>
        }
        modalStyle={{ height: "116px", width: "448px", padding: "32px 24px" }}
        bottomButtons={[]}
      />

      {showEditOrderModal && (
        <EditOrderModal
          setOriginalSettings={setOriginalSettings}
          onClose={() => setShowEditOrderModal(false)}
          originalInboundTeam={originalSettings?.inbound_team}
          connectToTeam={connectToTeam}
          callDistribution={callDistribution}
          vnId={originalSettings.id}
          allUsers={originalSettings?.all_users}
          allTeams={originalSettings?.all_teams}
          routingOrder={originalSettings?.routing_order}
        />
      )}
    </>
  );
}
const localStyles = {
  pNoOverflow: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "230px",
    margin: 0,
  },
};

export default IncomingTab;
